const MONTHS_SHORT = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

const MONTHS_LONG = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** `yyyy-MM-dd` in local time — `toISOString()` would shift the day. */
export function toISODate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function todayISO(): string {
  return toISODate(new Date());
}

export function fromISODate(iso: string): Date {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year, (month ?? 1) - 1, day ?? 1);
}

export function formatDate(iso: string): string {
  const date = fromISODate(iso);
  return `${date.getDate()} ${MONTHS_SHORT[date.getMonth()]} ${date.getFullYear()}`;
}

export function formatRelativeDate(iso: string): string {
  if (iso === todayISO()) return 'Today';

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  if (iso === toISODate(yesterday)) return 'Yesterday';

  return formatDate(iso);
}

/** `2026-08` -> `August 2026`. */
export function formatMonthKey(monthKey: string): string {
  const [year, month] = monthKey.split('-').map(Number);
  return `${MONTHS_LONG[(month ?? 1) - 1]} ${year}`;
}

/** `2026-08` -> `Aug 26`. Compact enough for a crowded chart axis. */
export function formatMonthShort(monthKey: string): string {
  const [year, month] = monthKey.split('-').map(Number);
  return `${MONTHS_SHORT[(month ?? 1) - 1]} ${String(year).slice(2)}`;
}

export function monthKeyOf(iso: string): string {
  return iso.slice(0, 7);
}

export function startOfMonthISO(date = new Date()): string {
  return toISODate(new Date(date.getFullYear(), date.getMonth(), 1));
}

export function startOfYearISO(date = new Date()): string {
  return toISODate(new Date(date.getFullYear(), 0, 1));
}

export function monthsAgoISO(months: number, date = new Date()): string {
  return toISODate(new Date(date.getFullYear(), date.getMonth() - months, 1));
}
